

exports.__esModule = true;
exports.$pxpCartDesc = $pxpCartDesc;

var _squid = require('squid');

function $pxpCartDesc() {
    // ask if the show desc treatment is present
    return (0, _squid.$pxp)('xo_hermesnodeweb_all_cart_DESC_v1', 'xo_hermesnodeweb_all_cart_DESC_Treatment').then(function (result) {
        return !!result;
    });
}

angular.value("$pxpCartDesc", $pxpCartDesc);
_squid.$pxp;


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-page-components/src/cart/lib/cart_pxp.js
 ** module id = 495
 ** module chunks = 1
 **/